import _ from 'lodash'
import cxs from 'cxs'
import flexboxGridStyles from 'flexboxgrid2/flexboxgrid2.css'

import styles from './styles.css'

// The number `0` with no unit is a valid CSS length, see:
//   https://www.w3.org/TR/CSS2/syndata.html#length-units
// Though it might be inappropriate/avoidable in certain contexts, if it is
// valid CSS, we should allow it.
const isTruthyOrZero = (value: string | number) => value || value === 0

export const asCsx = (name: string, value: any) =>
    isTruthyOrZero(value) ? cxs({ [name]: value }) : null

export const asPrefixString = (prefix: string, value: any) =>
    _.isString(value) && styles[`${prefix}${_.upperFirst(value)}`]

export const getFlexboxGridClass = (className: string) =>
    flexboxGridStyles && flexboxGridStyles[className]
        ? flexboxGridStyles[className]
        : className

export const gridClassMap: { [key: string]: string } = {
    xs: 'col-xs',
    sm: 'col-sm',
    md: 'col-md',
    lg: 'col-lg',
    xl: 'col-xl',
    xsOffset: 'col-xs-offset',
    smOffset: 'col-sm-offset',
    mdOffset: 'col-md-offset',
    lgOffset: 'col-lg-offset',
    xlOffset: 'col-xl-offset',
} as const

export const getGridPrefix = (key: string | number) => gridClassMap[key]
